// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../imgs/blob-warm-duo-2x.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._5YcpBNUBJJJjAel7o56R {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(90vh - var(--global-nav-height));
  padding-top: var(--space-l-2xl);
  background-color: var(--secondary-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position-x: calc(-1 * var(--space-3xl));
  background-position-y: 10%;
  background-size: auto 70%;
  background-repeat: no-repeat;
}

.IPEb9lebqjr4Xb7MLnvF {
  min-height: calc(80vh - var(--global-nav-height));
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: center;
  gap: var(--space-2xl);
  padding-inline: var(--space-4xs-5xl);
  max-width: var(--grid-max-width);
  margin-inline: auto;
}

.Lt6zEvVUZoYuAA92ybbS {
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  padding-inline: var(--space-2xl-3xl);
}

._PEsexsdeFW9uMSVsP2O,
.N9zVb6cAbso0YDDCpugF {
  display: flex;
  flex-direction: column;
}

.N9zVb6cAbso0YDDCpugF {
  flex: 1 1 calc((var(--space-3xl) * 2) + (var(--space-xl) * 2));
}

._PEsexsdeFW9uMSVsP2O {
  flex: 1 1 calc((var(--space-3xl) * 2) + (var(--space-xl) * 1));
}

._PEsexsdeFW9uMSVsP2O h2 {
  font-size: var(--step-3);
  font-weight: 700;
  line-height: 1.5;
  color: var(--white-color);
  margin-top: 0;
  margin-bottom: 1.5em;
  display: flex;
  justify-content: flex-start;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  unicode-bidi: isolate;
}

._PEsexsdeFW9uMSVsP2O p {
  color: var(--white-color);
  text-wrap: balance;
  font-size: var(--step-0);
  line-height: var(--base-line-height);
  margin-top: 0;
  margin-bottom: 1.5em;
  max-width: 90%;
  min-width: 70%;
}

img {
  border-style: none;
  max-width: 100%;
  overflow: clip;
  vertical-align: middle;
}

.IllAF2tINSosqvKc2yCn {
  width: 50%;
}

.BfJp5lVW_G5WfD53HNjX {
  margin-top: 0.5rem;
  width: 50%;
}

.XdgM5iYK7O5w1nmR8wNg {
  justify-content: flex-start;
  display: flex;
  flex-direction: row;
  align-content: center;
  width: 100%;
  margin-bottom: 2rem;
}

.NewIuHB9Pe_qqMowxN60 {
  background-color: transparent;
  padding: var(--space-2xs) 0 0;
  color: var(--white-color);
  font-size: var(--step--1);
  line-height: 1.5;
  font-weight: 500;
  min-width: 15rem;
}

.w3d0n6pRwbifhGScwsUs {
  --input-color: var(--secondary-color);
  --input-font-weight: 600;
  --input-font-size: var(--step-1);
  --input-bg-color: rgba(255, 255, 255, 0.487);
  --label-color: var(--white-color);
  --input-border-color: transparent;
  --input-padding-tb: var(--space-s);
  --input-padding-rl: var(--space-s);
  width: 18rem;
  --input-bg-color-hover: rgba(255, 255, 255, 0.504);
  --input-bg-color-focus: rgba(255, 255, 255, 0.611);
  --input-border-color-hover: transparent;
  --input-border-color-focus: transparent;
}

.PWWVx1D_Pp8jmvJswmjG {
  --input-font-weight: 600;
  --input-bg-color: rgba(255, 255, 255, 0.78);
  --input-bg-color-hover: rgba(255, 255, 255, 0.884);
  --input-bg-color-focus: rgb(255, 255, 255);
  --label-color: var(--white-color);
  --input-border-color: transparent;
  --input-padding-tb: var(--space-s);
  --input-padding-rl: var(--space-s);
  --input-border-color-hover: transparent;
  --input-border-color-focus: transparent;
  width: 12rem;
}

.w3d0n6pRwbifhGScwsUs .rzXQRXWCTS6EkHahh9Bv::after {
  color: var(--white-color);
}

._5YcpBNUBJJJjAel7o56R .w3d0n6pRwbifhGScwsUs label::after,
._5YcpBNUBJJJjAel7o56R .PWWVx1D_Pp8jmvJswmjG label::after {
  color: var(--white-color);
}

.w3d0n6pRwbifhGScwsUs label,
.PWWVx1D_Pp8jmvJswmjG label {
  margin-bottom: 0.5rem;
}

.TEksgQiqofGgIL0eXJdb {
  font-size: var(--step-5);
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.6);
  text-align: center;
  background: none;
  background-color: transparent;
  border: none;
  text-decoration: none;
  transition: var(--global-nav-transition);
  cursor: pointer;
  z-index: 200;
}

.TEksgQiqofGgIL0eXJdb:hover,
.TEksgQiqofGgIL0eXJdb:focus {
  color: rgba(255, 255, 255, 1);
  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.4);
}

.TEksgQiqofGgIL0eXJdb:active {
  color: rgba(255, 255, 255, 0.8);
  text-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);
}

.Ly1PVRtwrOib_gSUVNUY {
  margin-left: 2rem;
  display: flex;
  flex-direction: column;
  width: min-content;
  padding-bottom: 1rem;
  padding-inline: 0;
}

@media (max-width: 1750px) {
  .XdgM5iYK7O5w1nmR8wNg {
    flex-direction: column;
  }
}

@media only screen and (max-width: 500px) {
  .w3d0n6pRwbifhGScwsUs {
    width: 12rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/components/SubscribeSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iDAAiD;EACjD,+BAA+B;EAC/B,wCAAwC;EACxC,yDAAyD;EACzD,kDAAkD;EAClD,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;EACrB,oCAAoC;EACpC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,oCAAoC;EACpC,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,gCAAgC;EAChC,4CAA4C;EAC5C,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,YAAY;EACZ,kDAAkD;EAClD,kDAAkD;EAClD,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;EAC3C,kDAAkD;EAClD,0CAA0C;EAC1C,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,uCAAuC;EACvC,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".subscribe {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: calc(90vh - var(--global-nav-height));\n  padding-top: var(--space-l-2xl);\n  background-color: var(--secondary-color);\n  background-image: url(../../../imgs/blob-warm-duo-2x.png);\n  background-position-x: calc(-1 * var(--space-3xl));\n  background-position-y: 10%;\n  background-size: auto 70%;\n  background-repeat: no-repeat;\n}\n\n.sectionContent {\n  min-height: calc(80vh - var(--global-nav-height));\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-content: center;\n  gap: var(--space-2xl);\n  padding-inline: var(--space-4xs-5xl);\n  max-width: var(--grid-max-width);\n  margin-inline: auto;\n}\n\n.sectionContentPadding {\n  justify-content: space-around;\n  display: flex;\n  flex-direction: column;\n  padding-inline: var(--space-2xl-3xl);\n}\n\n.colR,\n.colL {\n  display: flex;\n  flex-direction: column;\n}\n\n.colL {\n  flex: 1 1 calc((var(--space-3xl) * 2) + (var(--space-xl) * 2));\n}\n\n.colR {\n  flex: 1 1 calc((var(--space-3xl) * 2) + (var(--space-xl) * 1));\n}\n\n.colR h2 {\n  font-size: var(--step-3);\n  font-weight: 700;\n  line-height: 1.5;\n  color: var(--white-color);\n  margin-top: 0;\n  margin-bottom: 1.5em;\n  display: flex;\n  justify-content: flex-start;\n  margin-block-start: 0.83em;\n  margin-block-end: 0.83em;\n  margin-inline-start: 0px;\n  margin-inline-end: 0px;\n  unicode-bidi: isolate;\n}\n\n.colR p {\n  color: var(--white-color);\n  text-wrap: balance;\n  font-size: var(--step-0);\n  line-height: var(--base-line-height);\n  margin-top: 0;\n  margin-bottom: 1.5em;\n  max-width: 90%;\n  min-width: 70%;\n}\n\nimg {\n  border-style: none;\n  max-width: 100%;\n  overflow: clip;\n  vertical-align: middle;\n}\n\n.inputGroupEmail {\n  width: 50%;\n}\n\n.inputGroupZip {\n  margin-top: 0.5rem;\n  width: 50%;\n}\n\n.inputGroupWrapper {\n  justify-content: flex-start;\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  width: 100%;\n  margin-bottom: 2rem;\n}\n\n.errorMessageField {\n  background-color: transparent;\n  padding: var(--space-2xs) 0 0;\n  color: var(--white-color);\n  font-size: var(--step--1);\n  line-height: 1.5;\n  font-weight: 500;\n  min-width: 15rem;\n}\n\n.emailInput {\n  --input-color: var(--secondary-color);\n  --input-font-weight: 600;\n  --input-font-size: var(--step-1);\n  --input-bg-color: rgba(255, 255, 255, 0.487);\n  --label-color: var(--white-color);\n  --input-border-color: transparent;\n  --input-padding-tb: var(--space-s);\n  --input-padding-rl: var(--space-s);\n  width: 18rem;\n  --input-bg-color-hover: rgba(255, 255, 255, 0.504);\n  --input-bg-color-focus: rgba(255, 255, 255, 0.611);\n  --input-border-color-hover: transparent;\n  --input-border-color-focus: transparent;\n}\n\n.zipInput {\n  --input-font-weight: 600;\n  --input-bg-color: rgba(255, 255, 255, 0.78);\n  --input-bg-color-hover: rgba(255, 255, 255, 0.884);\n  --input-bg-color-focus: rgb(255, 255, 255);\n  --label-color: var(--white-color);\n  --input-border-color: transparent;\n  --input-padding-tb: var(--space-s);\n  --input-padding-rl: var(--space-s);\n  --input-border-color-hover: transparent;\n  --input-border-color-focus: transparent;\n  width: 12rem;\n}\n\n.emailInput .required::after {\n  color: var(--white-color);\n}\n\n.subscribe .emailInput label::after,\n.subscribe .zipInput label::after {\n  color: var(--white-color);\n}\n\n.emailInput label,\n.zipInput label {\n  margin-bottom: 0.5rem;\n}\n\n.pageDownBtn {\n  font-size: var(--step-5);\n  color: rgba(255, 255, 255, 0.9);\n  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.6);\n  text-align: center;\n  background: none;\n  background-color: transparent;\n  border: none;\n  text-decoration: none;\n  transition: var(--global-nav-transition);\n  cursor: pointer;\n  z-index: 200;\n}\n\n.pageDownBtn:hover,\n.pageDownBtn:focus {\n  color: rgba(255, 255, 255, 1);\n  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.4);\n}\n\n.pageDownBtn:active {\n  color: rgba(255, 255, 255, 0.8);\n  text-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);\n}\n\n.pageDownBtnWrapper {\n  margin-left: 2rem;\n  display: flex;\n  flex-direction: column;\n  width: min-content;\n  padding-bottom: 1rem;\n  padding-inline: 0;\n}\n\n@media (max-width: 1750px) {\n  .inputGroupWrapper {\n    flex-direction: column;\n  }\n}\n\n@media only screen and (max-width: 500px) {\n  .emailInput {\n    width: 12rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subscribe": `_5YcpBNUBJJJjAel7o56R`,
	"sectionContent": `IPEb9lebqjr4Xb7MLnvF`,
	"sectionContentPadding": `Lt6zEvVUZoYuAA92ybbS`,
	"colR": `_PEsexsdeFW9uMSVsP2O`,
	"colL": `N9zVb6cAbso0YDDCpugF`,
	"inputGroupEmail": `IllAF2tINSosqvKc2yCn`,
	"inputGroupZip": `BfJp5lVW_G5WfD53HNjX`,
	"inputGroupWrapper": `XdgM5iYK7O5w1nmR8wNg`,
	"errorMessageField": `NewIuHB9Pe_qqMowxN60`,
	"emailInput": `w3d0n6pRwbifhGScwsUs`,
	"zipInput": `PWWVx1D_Pp8jmvJswmjG`,
	"required": `rzXQRXWCTS6EkHahh9Bv`,
	"pageDownBtn": `TEksgQiqofGgIL0eXJdb`,
	"pageDownBtnWrapper": `Ly1PVRtwrOib_gSUVNUY`
};
export default ___CSS_LOADER_EXPORT___;
